import { useContext, useState, useEffect } from 'react';
import React from 'react';
import useFormPageStyles from './styles';
import axios from 'axios';
import { formPageMock } from './mockData';
import PageContext from '../../contexts/pageContext';
import { postApiCallForm } from '../../utils/services';
import Button from '../../components/button';
const FormPage = ({ sectionData, extraProps = {} }) => {
  const [formData, setFormData] = useState({});

  const [formSubmitted, setformSubmitted] = useState(false);
  const metadata = sectionData?.components?.[0]?.metadata || formPageMock;

  const { _id, baseURLs, isMobile, countryCode } = useContext(PageContext);
  const classes = useFormPageStyles({ isMobile });
  const handleSubmit = async (e) => {
    e.preventDefault();
    let formResponse = [];
    for (const [key, value] of Object.entries(formData)) {
      if (value.questionType === 'MC') {
        if (value.solutionArray.length > 1) {
          value.solutionArray.shift();
        }
      }
      formResponse.push({
        questionId: key,
        questionName: value.questionName,
        questionType: value.questionType,
        solutionArray: value.solutionArray
      });
    }
    const data = {
      sectionId: sectionData?.components?.[0]?._id || null,
      landingPageId: _id || null,
      payload: formResponse
    };
    postApiCallForm(baseURLs, data, extraProps);
    setFormData({});
    setformSubmitted(!formSubmitted);
  };

  useEffect(() => {
    //add all questions to formData
    let formData = {};
    metadata.questions.forEach((question) => {
      formData[question._id] = {
        questionName: question.text,
        questionType: question.type,
        solutionArray: ['']
      };
    });
    setFormData(formData);
  }, [metadata, formSubmitted]);

  const handleOnClick = (e, item, option) => {
    // if the checkbox is checked
    if (!e.target.checked) {
      // if the checkbox is checked and the solution array is empty
      if (!formData[item._id]?.solutionArray?.length) {
        setFormData({
          ...formData,
          [item._id]: {
            questionName: item.text,
            solutionArray: [option.value],
            questionType: 'MC'
          }
        });
      }
      // if the checkbox is checked and the solution array is not empty and the value is already in the array remove it
      else if (formData[item._id]?.solutionArray?.includes(option.value)) {
        // if only one value is in the array remove it

        setFormData({
          ...formData,
          [item._id]: {
            questionName: item.text,
            solutionArray: formData[item._id]?.solutionArray?.filter(
              (item) => item !== option.value
            ),
            questionType: 'MC'
          }
        });
      }
    }
    // if the checkbox is unchecked
    else {
      // if the checkbox is unchecked and the solution array is empty
      if (typeof formData[item._id]?.solutionArray?.length === 'undefined') {
        setFormData({
          ...formData,
          [item._id]: {
            questionName: item.text,
            solutionArray: [option.value],
            questionType: 'MC'
          }
        });
      }
      // if the checkbox is unchecked and the solution array is not empty and the value is not in the array add it
      else if (!formData[item._id]?.solutionArray?.includes(option.value)) {
        setFormData({
          ...formData,
          [item._id]: {
            questionName: item.text,
            solutionArray: [...formData[item._id]?.solutionArray, option.value],
            questionType: 'MC'
          }
        });
      }
    }
  };

  return (
    <section className={classes.formPageSection}>
      <div className={classes.formPageFormContainer}>
        <form onSubmit={handleSubmit}>
          <div className={classes.formPageHeader}>
            <div className={classes.formPageTitle}>{metadata?.title}</div>
            <div className={classes.formPageSubtitle}>{metadata?.subTitle}</div>
          </div>
          {metadata?.questions?.map((item, index) => (
            <>
              {item.type === 'SA' && (
                <div className={classes.inputField}>
                  <label className={classes.inputFieldLabel}>
                    {item.text}{' '}
                    {item.isRequired && (
                      <span className={classes.inputFieldRequired}>*</span>
                    )}
                  </label>
                  <input
                    className={classes.inputFieldControl}
                    required={item.isRequired}
                    type="text"
                    value={formData[item._id]?.solutionArray?.[0] || ''}
                    placeholder="Short answer"
                    name={item._id}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [item._id]: {
                          index,
                          questionName: item.text,
                          solutionArray: [e.target.value],
                          questionType: 'SA'
                        }
                      });
                    }}
                  />
                </div>
              )}
              {item.type === 'MC' && (
                <div className={classes.checkboxField}>
                  <div className={classes.checkBoxFieldLabel}>
                    {item.text}{' '}
                    {item.isRequired && (
                      <span className={classes.inputFieldRequired}>*</span>
                    )}
                  </div>
                  {/* map the checkbox options  */}
                  {item.options.map((option, index) => (
                    <div className={classes.checkboxFieldControl}>
                      <input
                        value={option.value}
                        type="checkbox"
                        name={option.value}
                        checked={formData[item._id]?.solutionArray?.includes(
                          option.value
                        )}
                        id={option.value}
                        onClick={(e) => handleOnClick(e, item, option)}
                      />
                      <label htmlFor={option.value}>{option.value}</label>
                    </div>
                  ))}
                </div>
              )}
              {item.type === 'SC' && (
                <div className={classes.checkboxField}>
                  <div className={classes.checkBoxFieldLabel}>
                    {item.text}{' '}
                    {item.isRequired && (
                      <span className={classes.inputFieldRequired}>*</span>
                    )}
                  </div>
                  {/* map the radio options  */}
                  {item.options.map((option, index) => (
                    <div className={classes.checkboxFieldControl}>
                      <input
                        // value={option.value}
                        type="radio"
                        name={`text_${item._id}`}
                        required={item.isRequired}
                        value={option.value}
                        checked={
                          formData[item._id]?.solutionArray?.[0] ===
                          option.value
                        }
                        // name={option.value}
                        // id={option.value}
                        onClick={(e) => {
                          setFormData({
                            ...formData,
                            [item._id]: {
                              questionName: item.text,
                              solutionArray: [option.value],
                              questionType: 'SC'
                            }
                          });
                        }}
                      />
                      <label htmlFor={option.value}>{option.value}</label>
                    </div>
                  ))}
                </div>
              )}
            </>
          ))}
          <div className={classes.submitBtnContainer}>
            <Button
              data={{
                // link: 'headerData?.loginCtaLink',
                // isLink: 1,
                value: countryCode === 'KR' ? '제출하기' : 'SUBMIT'
                // isExternal: 1
              }}
              type={'primary'}
              size={'medium'}
              target={null}
              rel={null}
            />
          </div>
        </form>
      </div>
    </section>
  );
};

export default FormPage;
